import styled, { css } from 'styled-components';
import { colours } from 'themes/default';

export const StyledUnavailableSeatsWrapper = styled.div`
  cursor: pointer;
  position: relative;
  margin-top: 15px;
  padding: 5px 10px;
  background-color: #e3e3e3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;

  &: hover {
    background-color: ${colours.Greyscale.MistGrey};
  }

  ${(props) =>
    props.isOpen &&
    css`
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    `}
`;

export const StyledChevron = styled.span`
  font-size: 20px;
  margin-left: 10px;

  ${(props) =>
    props.isOpen &&
    css`
      transform: rotate(90deg);
    `}

  ${(props) =>
    props.shouldTransition &&
    css`
      transition: all 0.4s ease-in-out;
    `}
`;

export const ExpandableSection = styled.div`
  box-shadow: 0px 0px 30px #e3e3e3;
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 10px;
  overflow: hidden;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  border: solid 2px #e3e3e3;
`;

export const StyledBookingSeat = styled.span`
  cursor: pointer;
  background-color: #e3e3e3;
  border-radius: 20px;
  margin-right: 2px;
  padding: 0 8px;

  &:hover {
    & a {
      text-decoration: underline;
    }
  }

  & a {
    color: #00286a;
    text-decoration: none;
  }
`;

export const StyledContainer = styled.div`
  padding: 10px 0;
  border-bottom: solid 1px ${colours.Greyscale.MistGrey};
`;

export const StyledExpand = styled.div`
  display: flex;
  align-items: center;
`;
